import React from "react";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import GithubIcon from "@mui/icons-material/GitHub";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="socialMedia">
        <a
            href="https://www.linkedin.com/in/taha-murtaza/"
            // className={classes.link}
            target="_blank"
          >
            <LinkedInIcon />
          </a>
          <a
            href="mailto:iamtahamurtaza@gmail.com"
            // className={classes.link}
            target="_blank"
          >
            <EmailIcon />
          </a>
          <a
            href="https://github.com/mtaha-21"
            // className={classes.link}
            target="_blank"
          >
            <GithubIcon />
          </a>
      </div>
    </div>
  );
}

export default Footer;
